// extracted by mini-css-extract-plugin
export var statItem = "_jc-1";
export var statsRow = "_jc-0";